export default function FooterContainer() {
  const isTestEnvironment = ["localhost", "127.0.0.1", "::1"]
    .includes(window.location.hostname.toLowerCase());
  const environmentLabel = isTestEnvironment
    ? <span style={{color: "#ff4d4f", fontWeight: 700, textTransform: "uppercase"}}>Środowisko testowe</span>
    : null;

  return <div style={{alignItems: "center", display: "flex", gap: "48px", justifyContent: "center"}}>
    {environmentLabel}
    <span>Made by <a href="https://digimuth.com">Digimuth</a></span>
    {environmentLabel}
  </div>;
}
